import * as React from "react";
import type { SVGProps } from "react";
const SvgNoteMain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={52}
    fill="none"
    viewBox="0 0 50 52" {...props}
  >
    <g filter="url(#Note-Main_svg__a)">
      <path
        fill="#23F6E7"
        fillRule="evenodd"
        d="M9.467 11c0-.736.596-1.334 1.333-1.334h8c.736 0 1.333.598 1.333 1.334v10.667a.667.667 0 0 1-1.054.542l-.783-.56a2 2 0 0 0-2.325 0l-.784.56a.67.67 0 0 1-.775 0l-.783-.56a2 2 0 0 0-2.325 0l-.783.56a.667.667 0 0 1-1.054-.543zm2.666 1.666c0-.368.299-.666.667-.666h4a.667.667 0 0 1 0 1.333h-4a.667.667 0 0 1-.667-.667m.667 2a.667.667 0 0 0 0 1.334h4a.667.667 0 1 0 0-1.334zm0 2.667a.667.667 0 1 0 0 1.334h4a.667.667 0 0 0 0-1.334z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="Note-Main_svg__a"
        width={48.467}
        height={50.467}
        x={0.567}
        y={0.767}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={10} dy={10} />
        <feGaussianBlur stdDeviation={9.45} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.462745 0 0 0 0 0.556863 0 0 0 0 0.690196 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2257_4300"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2257_4300"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgNoteMain;
